<template>
  <form
    :data-vv-scope="id"
    :class="classList"
    novalidate
    @submit.prevent="validateForm()">
    <slot/>
  </form>
</template>

<script>
import generateId from '@/helpers/components/generateId';

export default {
  inject: ['$validator'],
  props: {
    inline:
    {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: generateId(),
    };
  },
  computed: {
    classList() {
      let value = '';

      if (this.inline) {
        value += ' form-inline';
      }

      return value;
    },
  },
  methods: {
    validateForm() {
      this.$validator.validateAll(this.id).then((result) => {
        if (result) {
          this.$emit('submit');
        }
      });
    },
  },
};
</script>
